// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_9e1425b4d3--wrapper--sD2VD","_loading":"_9e1425b4d3--_loading--fjIDR","results":"_9e1425b4d3--results--A8xyf","list-wrapper":"_9e1425b4d3--list-wrapper--oWs_b"};